var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4822 14.0002H14.7218L14.4575 13.7262C15.3912 12.5892 15.9591 11.1152 15.9591 9.50021C15.9591 5.91021 13.1724 3.00021 9.73444 3.00021C6.2965 3.00021 3.50977 5.91021 3.50977 9.50021C3.50977 13.0902 6.2965 16.0002 9.73444 16.0002C11.281 16.0002 12.6916 15.4082 13.7805 14.4342L14.0448 14.7082V15.5002L18.8311 20.4912L20.2589 19.0002L15.4822 14.0002ZM9.73418 14C7.35348 14 5.42479 11.986 5.42479 9.50003C5.42479 7.01503 7.35348 5.00003 9.73418 5.00003C12.1139 5.00003 14.0436 7.01503 14.0436 9.50003C14.0436 11.986 12.1139 14 9.73418 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c6372c68bd304f72e185cefbc57aed5c.svg";
export { ForwardRef as ReactComponent };